/**
 * Makes an ajax request and calls the error or success callback
 * Assumes CORS for cross-domain requests, not JSONP
 *
 * @param {Object} config
 * @param {Function} config.errorCallback - function called if there is an error
 * @param {Function} config.successCallback - function called if there is a success
 * @param {string} config.url - url for get
 * @return {null}
 */

function makeRequest(config) {
    var onError = config.errorCallback || function() {};
    var onSuccess = config.successCallback || function() {};
    var request = new XMLHttpRequest();
    request.open('GET', config.url || '', true);
    request.timeout = 5000; // time in milliseconds
    request.withCredentials = true;
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('pageReturnUrl', window.location.href);
    addTrackingInfoForExpSvc(request);
    request.responseType = 'json';
    request.onload = function() {
        if (this.status < 200 || this.status >= 400) {
            onError(request.response);
        } else {
            onSuccess(request.response);
        }
    };
    request.onerror = onError;
    request.ontimeout = onError;
    request.send();
}

function addTrackingInfoForExpSvc(request) {
    var trackingInfo;
    try {
        trackingInfo = window.trkCorrelationSessionInfo.getTrackingInfo();
    } catch (e) { /* no-op */ }
    if (trackingInfo && trackingInfo.X_EBAY_C_CORRELATION_SESSION) {
        request.setRequestHeader('X-EBAY-C-CORRELATION-SESSION', trackingInfo.X_EBAY_C_CORRELATION_SESSION);
    }
}

module.exports = makeRequest;
